import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationPolicyIntentProjectDetachArgs,
  PolicyIntentProjectAttachment,
} from "types/generated";

export const DETACH_POLICY_FROM_INTENT_PROJECT: TypedDocumentNode<
  { policyIntentProjectDetach: PolicyIntentProjectAttachment },
  MutationPolicyIntentProjectDetachArgs
> = gql`
  mutation DetachPolicyFromIntentProject($id: ID!) {
    policyIntentProjectDetach(id: $id) {
      id
    }
  }
`;
